import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { PoClosureRequest } from "models/po-closure";
import { useAuth } from "src/contexts/AuthContext";

export const usePoClosureRequest = () => {
  const [request, setRequest] = useState<PoClosureRequest | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchPoClosureRequest = async (requestId: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(`${API_URL}/po-closures/${requestId}`, {
        method: "GET",
      });
      const data = await checkResponse(response);
      setRequest(data as PoClosureRequest);
    } catch (requestError) {
      console.error("Error fetching PO closure request:", requestError);
      setError("Failed to fetch PO closure request.");
      setRequest(null);
    } finally {
      setLoading(false);
    }
  };

  return { request, loading, error, fetchPoClosureRequest };
};
